import { jsx as l, jsxs as n } from "react/jsx-runtime";
import { NeuTag as f } from "@hcahealthcaredpx/neutron-react";
import { U as p } from "./unified-link.DNdCokeG.js";
const g = ({
  className: d,
  children: m,
  onClick: c,
  subTitle: a,
  tag: o,
  title: e,
  url: i,
  titleClassname: t = "mb-2"
}) => {
  const r = e && i ? { value: { href: i, text: e } } : null, s = r ? /* @__PURE__ */ l(
    p,
    {
      className: "neu-display-4 fw-bold mb-0",
      editable: !1,
      field: r,
      onClick: c,
      children: e
    }
  ) : null;
  return /* @__PURE__ */ l("div", { className: "py-1", children: /* @__PURE__ */ n("div", { className: d, children: [
    /* @__PURE__ */ l(f, { className: "mb-2", color: "gray", children: o }),
    (s || a) && /* @__PURE__ */ n("div", { className: t, children: [
      s,
      a
    ] }),
    m
  ] }) });
};
export {
  g as T
};
